/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/5/26 added to support impacted workflow
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedWorkflowConfig {
    name: string;
    type: string;
    setting: string;

    static parse(serverResponse): Array<ImpactedWorkflowConfig> {
        const serverRes = serverResponse['screen-list'];
        if (!serverRes) {
            return null;
        }

        const impactedWorkflowConfig: Array<ImpactedWorkflowConfig> = [];

        // Helper function to extract and format relevant fields
        const extractFields = (fieldObj: any): string => {
            if (!fieldObj) return '';

            const result: string[] = [];
            const startFields: string[] = [];

            for (const key in fieldObj) {
                const value = fieldObj[key];

                // Handle specific true-flag field
                if (key === businessConstants.impactedWorkflow.relationship && value === 'true') {
                    startFields.push(key);
                }

                //  Add presence of "Filter Criteria" without parsing its value
                if (key === businessConstants.impactedWorkflow.filterCriteria) {
                    startFields.push(key);
                }

                // Add true-flag fields to <<Details>>, such as "Access list"
                if (key === businessConstants.impactedWorkflow.accessList && value === 'true') {
                    result.push(`<<Details>>${key}`);
                }

                //  Parse taskList fields
                if (key === 'taskList' && Array.isArray(value)) {
                    value.forEach(task => {
                        const taskName = `Task-${task.name}`;
                        const fieldValuesSet = new Set<string>();

                        if (Array.isArray(task.fields)) {
                            task.fields.forEach(f => {
                                const fieldKey = Object.keys(f)[0];
                                const fieldValue = f[fieldKey];
                                fieldValuesSet.add(fieldValue);
                            });
                        }

                        // key-value pairs where value === 'true'
                        for (const tKey in task) {
                            if (tKey !== 'name' && tKey !== 'id' && task[tKey] === 'true') {
                                fieldValuesSet.add(tKey);
                            }
                        }

                        const uniqueValues = Array.from(fieldValuesSet);
                        if (uniqueValues.length > 0) {
                            result.push(`<<${taskName}>>${uniqueValues.join(',')}`);
                        }
                    });
                }

                // Parse gatewayCondition fields
                if (key === businessConstants.impactedWorkflow.gatewayCondition && Array.isArray(value)) {
                    const gatewayValuesSet = new Set<string>();

                    value.forEach(g => {
                        if (Array.isArray(g.field)) {
                            g.field.forEach(f => {
                                const fieldKey = Object.keys(f)[0];
                                const fieldValue = f[fieldKey];
                                gatewayValuesSet.add(fieldValue);
                            });
                        }
                    });

                    const uniqueGatewayValues = Array.from(gatewayValuesSet);
                    if (uniqueGatewayValues.length > 0) {
                        result.push(`<<${businessConstants.impactedWorkflow.gatewayCondition}>>${uniqueGatewayValues.join(',')}`);
                    }
                }

                // Parse automation task names
                // Parse automation field names
                if (key === businessConstants.impactedWorkflow.automation && Array.isArray(value)) {
                    const automationFields = new Set<string>();
                    value.forEach(a => {
                        if (a.fieldName) {
                            automationFields.add(a.fieldName);
                        }
                    });

                    const uniqueFields = Array.from(automationFields);
                    if (uniqueFields.length > 0) {
                        result.push(`<<${businessConstants.impactedWorkflow.automation}>>${uniqueFields.join(',')}`);
                    }
                }
            }

            // If there are any <<Start>> fields, prepend them as a single entry
            if (startFields.length > 0) {
                result.unshift(`<<Start>>${startFields.join(',')}`);
            }

            return [...new Set(result)].join('');
        };

        // Iterate through each config node and construct the output array
        serverRes.forEach(item => {
            impactedWorkflowConfig.push({
                name: item.name,
                type: businessConstants.impactedConfigType.workflow,
                setting: extractFields(item.field)
            });
        });

        return impactedWorkflowConfig;
    }
}
